import { setSentryUserId, clearSentryUser } from '@/sentry'

export default {
    name: 'Login',
    state: {
      user: null,
      auth: null,
      permissions: null,
      api_key: null,
      kazang_api_key: null,
      session_id: null,
      userInfo: null,
      branch: null,
      store_id: null,
    },
    getters: {
      CurrentUser: (state) => state.user,
      CurrentUserInfo: (state) => state.userInfo,
      getterApikey: (state) => state.api_key,
      getKazangApiKey: (state) => {
        console.log('[LoginModule] Getting kazang_api_key from state:', state.kazang_api_key);
        return state.kazang_api_key;
      },
      getBranch: (state) => state.branch,
      getUserRole: (state) => state.permissions,
      getStoreId: (state) => state.store_id,
    },
    mutations: {
      setBranch: (state, branchData) => {
        console.log('[LoginModule] setBranch called with:', branchData);
        state.branch = branchData;
        // Extract kazang_api_key and store_id from branch data
        if (branchData && branchData.kazang_api_key) {
          console.log('[LoginModule] Setting kazang_api_key from branch:', branchData.kazang_api_key);
          state.kazang_api_key = branchData.kazang_api_key;
        } else {
          console.log('[LoginModule] No kazang_api_key in branch data');
        }
        if (branchData && branchData.store_id) {
          console.log('[LoginModule] Setting store_id from branch:', branchData.store_id);
          state.store_id = branchData.store_id;
        } else {
          console.log('[LoginModule] No store_id in branch data');
        }
      },
      resetLoginState: (state) => {
        state.user = null;
        state.auth = null;
        state.permissions = null;
        state.api_key = null;
        state.kazang_api_key = null;
        state.session_id = null;
        state.userInfo = null;
        state.branch = null;
      },
    },
    actions: {
      logIn: async (context, payload) => {
        return await axios.post(`${pettyCashApi}auth/login`, payload)
          .then(({data}) => {
            context.state.user = data;
            const id = data && (data.id ?? data.userId)
            if (id !== undefined && id !== null && id !== '') {
              setSentryUserId(id)
            }
            return data;
          }).catch(err => {
            errorHandler.tomcatError(err);
            throw err;
          })
      },
      verifyOtp: async (context, payload) => {
        return axios.post(pettyCashApi + 'auth/verify', payload)
          .then(async ({data}) => {
            console.log('[LoginModule] verifyOtp response data:', data);
            context.state.api_key = data.api_key;
            context.state.permissions = data.permissions;
            context.state.session_id = data.session_id;
            context.state.userInfo = data.userInfo;
            const id = data && data.userInfo && (data.userInfo.id ?? data.userInfo.userId)
            if (id !== undefined && id !== null && id !== '') {
              setSentryUserId(id)
            }
            return data;
          }).catch(err => {
            errorHandler.tomcatError(err);
            throw err;
          })
      },
      logout: async (context) => {
        // Reset module state and trigger persistence
        context.commit('resetLoginState');
        clearSentryUser()
      },
    }
}
